<noda-hero-wrapper>
  <noda-badge-with-label [redesigned]="true" />
  <noda-hero-info
    [configuration]="data"
    [titleTemplateRef]="titleComponent"
  />
  <button
    *nodaResponsiveIf="[enMinWidthScreen.XXL]"
    aria-label="Scroll Button"
    nodaScrollToNextElement
    class="hero-scroll-down"
    [scrollElementTag]="'noda-main-hero-v2'"
  ></button>
</noda-hero-wrapper>

<ng-template #titleComponent>
  <h1 class="h1-title">
    @for (title of titlesData; track $index) {
      <noda-translate [key]="title" />
      @if ($index | equal: 1) {
        <br class="title-break" />
      }
    }
  </h1>
</ng-template>
